import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useImportErrorModal = () => {
  const { t } = useTranslation();
  const [isImportErrorModalVisible, setIsImportErrorModalVisible] = useState(false);
  const [importErrorMessage, setImportErrorMessage] = useState('');

  const handleImportError = (error: unknown) => {
    const defaultMessage = t('notifications.somethingWentWrong');
    let message = '';

    if (error && typeof error === 'object') {
      if ('data' in error) {
        const errorData = (error as { data?: { message?: unknown } }).data;
        const { message: rawMessage } = errorData || {};

        if (typeof rawMessage === 'string') {
          message = rawMessage;
        } else if (Array.isArray(rawMessage) && rawMessage.length > 0) {
          const firstItem = rawMessage[0];

          if (typeof firstItem === 'string') {
            message = firstItem;
          } else if (Array.isArray(firstItem) && firstItem.length > 0) {
            const nestedItem = firstItem[0];

            if (typeof nestedItem === 'string') {
              message = nestedItem;
            } else if (nestedItem
              && typeof nestedItem === 'object'
              && 'error' in nestedItem
              && typeof (nestedItem as { error?: string }).error === 'string') {
              message = (nestedItem as { error?: string }).error || '';
            }
          }
        } else if (rawMessage
          && typeof rawMessage === 'object'
          && 'error' in (rawMessage as { error?: string })
          && typeof (rawMessage as { error?: string }).error === 'string') {
          message = (rawMessage as { error?: string }).error || '';
        }
      } else if ('error' in error && typeof (error as { error?: string }).error === 'string') {
        message = (error as { error?: string }).error || '';
      }
    }

    setImportErrorMessage(message || defaultMessage);
    setIsImportErrorModalVisible(true);
  };

  const handleCloseImportErrorModal = () => {
    setIsImportErrorModalVisible(false);
    setImportErrorMessage('');
  };

  return {
    isImportErrorModalVisible,
    importErrorMessage,
    handleImportError,
    handleCloseImportErrorModal,
  };
};

export default useImportErrorModal;
